import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

const GOOGLE_MAPS_SCRIPT_ID = 'google-maps-script';
const GOOGLE_MAPS_BASE_URL = 'https://maps.googleapis.com/maps/api/js';

@Injectable({ providedIn: 'root' })
export class GoogleMapsLoaderService {
  private loadPromise: Promise<void> | null = null;

  load(): Promise<void> {
    if (!environment.mapsKey) {
      return Promise.reject(new Error('Google Maps is not configured for this build.'));
    }

    if (this.loadPromise) {
      return this.loadPromise;
    }

    if (typeof google !== 'undefined' && google.maps) {
      this.loadPromise = Promise.resolve();
      return this.loadPromise;
    }

    this.loadPromise = new Promise<void>((resolve, reject) => {
      if (typeof google !== 'undefined' && google.maps?.Map) {
        resolve();
        return;
      }

      const callbackName = '__googleMapsCallback';
      const win = window as unknown as Record<string, unknown>;
      win[callbackName] = () => {
        delete win[callbackName];
        resolve();
      };

      const existingScript = document.getElementById(GOOGLE_MAPS_SCRIPT_ID);
      if (existingScript) {
        existingScript.remove();
      }

      const script = document.createElement('script');
      script.id = GOOGLE_MAPS_SCRIPT_ID;
      script.src = `${GOOGLE_MAPS_BASE_URL}?key=${environment.mapsKey}&libraries=places&callback=${callbackName}`;
      script.async = true;
      script.defer = true;
      script.addEventListener('error', () => reject(new Error('Failed to load Google Maps API')));
      document.head.appendChild(script);
    });

    return this.loadPromise;
  }
}
